if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(DeviceDetector.isMobile() || DeviceDetector.isTablet()) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });
    }

    async getSearchResults(searchTerm) {
      /* 31.10.2026 BONESWIMMER (Codex Г15): a late answer for an older query must not replace the
         results of the query now in the field — abort the previous request and compare the term. */
      if (this.abortController) this.abortController.abort();
      const controller = new AbortController();
      this.abortController = controller;
      const isCurrent = () =>
        this.isOpen && this.abortController === controller && this.input.value.trim() === searchTerm;
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${encodeURIComponent(searchTerm)}&resources[type]=product,page,article,collection,query&resources[limit]=8&section_id=predictive-search`,
          { signal: controller.signal }
        );

        if (!isCurrent()) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        if (!isCurrent()) {
          return;
        }
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        if (error && error.name === 'AbortError') return;
        if (!isCurrent()) return;
        this.errorMessageText.textContent = PredictiveSearch.errorText();
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    static errorText() {
      const lang = ((window.Shopify && Shopify.locale) || document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
      const m = {
        it: 'Non siamo riusciti a caricare i risultati. Riprova tra poco.',
        en: 'We couldn\u2019t load the results. Please try again shortly.',
        de: 'Die Ergebnisse konnten nicht geladen werden. Versuch es gleich noch einmal.',
        fr: 'Impossible de charger les r\u00e9sultats. R\u00e9essaie dans un instant.',
        es: 'No hemos podido cargar los resultados. Vuelve a intentarlo en un momento.',
        nl: 'De resultaten konden niet worden geladen. Probeer het zo opnieuw.',
        pl: 'Nie uda\u0142o si\u0119 wczyta\u0107 wynik\u00f3w. Spr\u00f3buj ponownie za chwil\u0119.',
        pt: 'N\u00e3o foi poss\u00edvel carregar os resultados. Tenta novamente daqui a pouco.',
      };
      return m[lang] || m.en;
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      clearTimeout(this.timeout);
      if (this.abortController) this.abortController.abort();
      this.abortController = null;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
